import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "menu", "chevron"]

  connect() {
    this.close()
    document.addEventListener('click', this.clickOutside)
    document.addEventListener('keydown', this.handleKeydown)
  }

  disconnect() {
    document.removeEventListener('click', this.clickOutside)
    document.removeEventListener('keydown', this.handleKeydown)
  }

  clickOutside = (event) => {
    if (!this.element.contains(event.target) && this.menuTarget.classList.contains('block')) {
      this.close()
    }
  }

  handleKeydown = (event) => {
    if (event.key === 'Escape' && this.menuTarget.classList.contains('block')) {
      this.close()
      if (this.hasButtonTarget) this.buttonTarget.focus()
    }
  }

  toggle() {
    if (this.menuTarget.classList.contains('hidden')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.menuTarget.classList.remove('hidden')
    this.menuTarget.classList.add('block')
    if (this.hasButtonTarget) this.buttonTarget.setAttribute('aria-expanded', 'true')
    if (this.hasChevronTarget) this.chevronTarget.classList.add('rotate-180')
  }

  close() {
    this.menuTarget.classList.remove('block')
    this.menuTarget.classList.add('hidden')
    if (this.hasButtonTarget) this.buttonTarget.setAttribute('aria-expanded', 'false')
    if (this.hasChevronTarget) this.chevronTarget.classList.remove('rotate-180')
  }
}
